import { createVanIconComponent } from "./van"

const EnvelopOutlined = createVanIconComponent("envelop-o")
export default EnvelopOutlined
